export default __webpack_public_path__ + "static/media/wood1.f5276588.jpg";